// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bgImg[data-v-520c0e3e] {\n  z-index: 0;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  background-size: cover;\n}\n.bgImg__img[data-v-520c0e3e], .bgImg__overlay[data-v-520c0e3e] {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
